import { IdTokenClaims } from '@/auth/idTokenClaims';

export default class UserState {
  public profile?: IdTokenClaims;
  public editor?: boolean;
  public queueEditor?: boolean;
}
